import { useContext } from 'react';

import AuthState from './AuthState';

export const useCurrentUser = () => {
  const { state, unauthenticate, getUserDetails, changeDefaultScore } = useContext(AuthState);

  const hasPermission = (permissionName: string) => {
    return (
      state.user &&
      state.user.permissions &&
      !!state.user.permissions.find((permission) => permission.name === permissionName)
    );
  };

  return {
    user: state.user,
    token: state.token,
    hasPermission,
    refetchUserDetails: getUserDetails,
    unauthenticate,
    changeDefaultScore,
  };
};

export const useLicenseExpires = (): Date | null => {
  const { state } = useContext(AuthState);

  return state.licenseExpires;
};
